import { RouteObject } from "react-router-dom";
import HomePage from "../routes/HomePage";
import { HomeRoutesConfig } from "./config";

export const HomeRoutes: RouteObject = {
  path: HomeRoutesConfig.homePage,
  index: true,
  element: <HomePage />,
};
